import { patchRequest } from '@/core';
import { globalAddresses } from '@/requests';

export default async function updateGlobalAddressRequest(id, patch) {
	let url = globalAddresses.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}
